import { MERCHANT_CONFIG } from '@hero/constants';
import { useGetMerchant } from '@hero/services/merchant-service/hooks';

import { BrandFilter } from './BrandFilter';
import { CategoryFilter } from './CategoryFilter';
import { CollectionFilter } from './CollectionFilter';
import { PriceFilter } from './PriceFilter';
import * as S from './style';

function ProductFilters({ parentRef }) {
  const { data: merchantData } = useGetMerchant({ options: { includeConfigs: true } });

  return (
    <S.ProductFilters>
      <PriceFilter />
      {merchantData?.configs[MERCHANT_CONFIG.categoryFilters]?.data?.map(category => (
        <CategoryFilter key={category.id} categoryId={category.categoryId} label={category.name} />
      ))}
      <CollectionFilter />
      <BrandFilter parentRef={parentRef} />
    </S.ProductFilters>
  );
}

export { ProductFilters };
